import { useMsal } from "@azure/msal-react";
import { Grid, Stack, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Floaticons from "../Floaticons";
import "./ManualTesting.css";
import "./SREContent.css";
import ToscaLearningCards from "./ToscaLearningCards";
import ToscaLearningJourney from "./ToscaLearningJourney";

function ToscaContent() {
 const { instance } = useMsal();
 const [username, setuserName] = useState(null);
 const [isUserPresent, setuserPresent] = useState(true);
 const [value, setValue] = React.useState("1");
 const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: "none",
  minWidth: 0,
  [theme.breakpoints.up("sm")]: {
   minWidth: 0,
  },
  fontWeight: 500,
  fontSize: "16px",
  marginRight: theme.spacing(1),
  color: "white",
  background: "#344B5D",
  borderRadius: "50px",

  "&.Mui-selected": {
   color: "#141414",
   fontWeight: 600,
   fontSize: "16px",

   backgroundColor: "#F0F0F0",
  },
  "&.Mui-focusVisible": {
   backgroundColor: "#F0F0F0",
  },
 }));
 const handleChange = (event, newValue) => {
  setValue(newValue);
 };
 //const baseURL = "http://localhost:3004";
 const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
 let program = "TOSCA";
 const activeAccount = instance.getActiveAccount();
 //  const checkUserPresent = (name) => {
 //   axios
 //    .get(`${baseURL}/checkNominationList/${name}/${program}`, {
 //     headers: {
 //      "Cache-Control": "no-cache",
 //      Accept: "application/json",
 //      Pragma: "no-cache",
 //      Expires: "0",
 //     },
 //    })
 //    .then((res) => {
 //     console.log("Reponse is", res.data);
 //     let users = res.data;
 //     axios
 //      .get(`${baseURL}/checkAdminList/${name}`, {
 //       headers: {
 //        "Cache-Control": "no-cache",
 //        Accept: "application/json",
 //        Pragma: "no-cache",
 //        Expires: "0",
 //       },
 //      })
 //      .then((res) => {
 //       console.log("Reponse is", res.data);

 //       users.length != 0 || res.data.length != 0
 //        ? setuserPresent(true)
 //        : setuserPresent(false);
 //      })
 //      .catch((err) => {
 //       console.log(err);
 //      });
 //    })
 //    .catch((err) => {
 //     console.log(err);
 //    });
 //  };

 const checkUserPresent = (name) => {
  axios
   .get(`${baseURL}/checkUserActive/${name}`, {
    headers: {
     "Cache-Control": "no-cache",
     Accept: "application/json",
     Pragma: "no-cache",
     Expires: "0",
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   })
   .then((res) => {
    let activeUser = res.data;
    if (activeUser.length != 0) {
     axios
      .get(`${baseURL}/checkNominationList/${name}/${program}`, {
       headers: {
        "Cache-Control": "no-cache",
        Accept: "application/json",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
       },
      })
      .then((res) => {
       let users = res.data;
       users.length != 0 ? setuserPresent(true) : setuserPresent(false);
      })
      .catch((err) => {
       console.log(err);
      });
    } else {
     axios
      .get(`${baseURL}/checkAdminList/${name}`, {
       headers: {
        "Cache-Control": "no-cache",
        Accept: "application/json",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
       },
      })
      .then((res) => {
       console.log("Reponse is", res.data);

       res.data.length != 0 ? setuserPresent(true) : setuserPresent(false);
      })
      .catch((err) => {
       console.log(err);
      });
    }
   })
   .catch((err) => {
    console.log(err);
   });
 };
 useEffect(() => {
  if (activeAccount) {
   setuserName(activeAccount.idTokenClaims.enterpriseID);

   checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
  } else {
   setuserName(null);
  }
 }, [activeAccount.idTokenClaims.enterpriseID]);
 return (
  <>
   <div id="manualTesting">
    <div className="main-banner">
     <img src="images/tosca/banner.png" alt="Banner" className="banner-img" />
     <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" />
     <div className="announcemnt-box">
      <p>
       <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
       <marquee
        width="92%"
        direction="left"
        style={{ display: "inline-block", verticalAlign: "middle" }}
       >
        {" "}
        <b>Come Join Us</b> on an exhilarating learning Journey on ABC University
        Platform!!!
       </marquee>
      </p>
     </div>
     <Floaticons />
    </div>
    {isUserPresent ? (
     <div className="main-container">
      {/* section 1  */}
      <div className="about-container">
       <div className="about-wrap">
        <h2>About TOSCA</h2>
        <p>
         TOSCA is a zero scripting, model based, continuous testing platform used to
         perform end to end test automation. It provides various tools for automating user
         interactions on applications built using different technologies like HTML, SAP,
         Salesforce etc.
        </p>
       </div>
      </div>
      {/* section 2  */}
      {/* <div className="program-container">
       <div className="program-wrap">
        <TabContext value={value}>
         <Box sx={{ borderBottom: 1, borderColor: "#B6C6F9" }}>
          <TabList
           role="tablist"
           sx={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "10px" }}
           onChange={handleChange}
           aria-label="lab API tabs example"
          >
           <AntTab label="Program Objectives" value="1" role="tab" />
           <AntTab label="Recordings & Guidelines" value="2" role="tab" />
          </TabList>
         </Box>
         <TabPanel value="1" sx={{ marginTop: "40px" }} role="tabpanel">
          {" "}
          <Stack direction={"row"}>
           <Box sx={{ width: "60%" }}>
            <ul>
             <li>Understand features and advantages of TOSCA. </li>
             <li>Illustrate how to use different features of TOSCA XSCAN.</li>
             <li>Understand how to create Modules, TestCases in TOSCA. </li>
             <li>Perform automated web testing using TOSCA. </li>
             <li>Implement reusability using Libraries in TOSCA. </li>
             <li>Handle Dynamic web elements. </li>
            </ul>
           </Box>
           <Box>
            <ul>
             <li>
              Understand error handling in TOSCA using Recovery Scenarios and Clean-Up
              Scenarios.{" "}
             </li>
             <li>
              Ability to design Data driven Testing using TestCase Design section from
              TOSCA.{" "}
             </li>
             <li>Understand importance of different standard modules in TOSCA. </li>
             <li>Perform automated API testing using TOSCA. </li>
            </ul>
           </Box>
          </Stack>
         </TabPanel>
         <TabPanel sx={{ marginTop: "40px" }} value="2" role="tabpanel">
          <Box sx={{ justifyContent: "center", display: "flex", alignItems: "center" }}>
           <Stack
            direction={"row"}
            spacing={2}
            sx={{
             height: "200px",
             display: "flex",
             width: "80%",
             justifyContent: "space-between",
            }}
           >
          

            <Stack
             sx={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
             spacing={3}
            >
             <iframe
              id="kmsembed-1_bq2uidwq"
              width="300"
              height="900"
              src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_bq2uidwq/uiConfId/27188232/st/0"
              class="kmsembed"
              allowfullscreen
              webkitallowfullscreen
              mozAllowFullScreen
              allow="autoplay *; fullscreen *; encrypted-media *"
              referrerPolicy="no-referrer-when-downgrade"
              frameborder="0"
              title="Shell University TOSCA- Kickoff Call"
             ></iframe>

             <Stack direction={"row"} spacing={0}>
              <Typography>Kick off</Typography>
              <img
               style={{ width: "30px", height: "28px " }}
               src="images/tosca/arrow.png"
              ></img>
             </Stack>
            </Stack>
            <Stack
             sx={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
             spacing={3}
            >
             <iframe
              id="kmsembed-1_k55xmu1n"
              width="300"
              height="300"
              src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_k55xmu1n/uiConfId/27188232/st/0"
              class="kmsembed"
              allowfullscreen
              webkitallowfullscreen
              mozAllowFullScreen
              allow="autoplay *; fullscreen *; encrypted-media *"
              referrerPolicy="no-referrer-when-downgrade"
              frameborder="0"
              title="Shell University _ TOSCA Tech Kick off-call"
             ></iframe>
             <Stack direction={"row"} spacing={0}>
              <Typography>Tech Kick off</Typography>
              <img
               style={{ width: "30px", height: "28px " }}
               src="images/tosca/arrow.png"
              ></img>
             </Stack>
            </Stack>
            <Stack
             sx={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
             onClick={() =>
              window.open("pdf/User_Guide_TOSCA_Installation__LKM_QE_V1.0 (1).pdf")
             }
             spacing={2}
            >
             <img
              style={{ width: "250px", height: "150px" }}
              src="images/tosca/userGuideline.png"
             ></img>
             <Stack direction={"row"} spacing={0}>
              <Typography>User Guideline</Typography>
              <img
               style={{ width: "30px", height: "28px " }}
               src="images/tosca/arrow.png"
              ></img>
             </Stack>
            </Stack>
           </Stack>
          </Box>
         </TabPanel>
        </TabContext>
     
       </div>
      </div> */}
      <div id="SRE-Objective">
       <div className="program-container">
        <div className="program-wrap">
         <h2>Program Objectives</h2>
         <Grid container sx={{ marginBottom: "1rem" }}>
          <Grid item xs={8}>
           <Stack spacing={1}>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography>Understand features and advantages of TOSCA.</Typography>
            </Stack>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography>
              Illustrate how to use different features of TOSCA XSCAN.
             </Typography>
            </Stack>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography>
              Understand how to create Modules, TestCases in TOSCA.
             </Typography>
            </Stack>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography>Perform automated web testing using TOSCA.</Typography>
            </Stack>
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography>Implement reusability using Libraries in TOSCA.</Typography>
            </Stack>

            <Stack direction={"row"} spacing={1} alignItems={"center"}>
             <img
              style={{ width: "16px", height: "16px" }}
              src="images/bulletWhite.png"
             ></img>
             <Typography> Handle Dynamic web elements.</Typography>
            </Stack>
           </Stack>
          </Grid>
         </Grid>
         {/* <ul id="double">
          <li>Understand features and advantages of TOSCA. </li>
          <li>Illustrate how to use different features of TOSCA XSCAN.</li>
          <li>Understand how to create Modules, TestCases in TOSCA. </li>
          <li>Perform automated web testing using TOSCA. </li>
          <li>Implement reusability using Libraries in TOSCA. </li>
          <li>Handle Dynamic web elements. </li>
         </ul> */}
        </div>
       </div>
      </div>
      {/* section 3  */}
      <ToscaLearningJourney />
      <div className="casestudyNote">
       <p>
        <strong>Note: </strong>For Case Study details, please contact{" "}
        <a href="mailto:LKM.ABCUniversity@accenture.com">
         LKM.ABCUniversity@accenture.com
        </a>
       </p>{" "}
      </div>
      {/* section 4  */}
      {/* <div className="external-certification-container">
       <h5>External Certifications</h5>
       <p>
        Complete your learning journey and earn accredited external certification in the
        area of your expertise which can help in advancing your career.
       </p>
       <div className="ex-wrapper">
        <div className="ex-box">
         <img src="images/PowerBi/certifications/1.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
        <div className="ex-box">
         <img src="images/PowerBi/certifications/2.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
        <div className="ex-box">
         <img src="images/PowerBi/certifications/4.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
       </div>
      </div> */}
      {/* section 5  */}
      <ToscaLearningCards />
      {/* section 6  */}
      <div className="features-container SRE">
       <h5>Program Highlights</h5>
       <div className="features-wrap">
        <div className="features-row">
         <img
          src="images/SRE/feature-icon1.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Self-paced Learning</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon2.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>SME Connects</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon3.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Final Assessment</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon4.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Earn Completion Certificates, Flair, R&R</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon6.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>End-to-End case studies</p>
        </div>
       </div>
      </div>
     </div>
    ) : (
     <div className="alter-conatiner">
      <p>
       You are not enrolled to this learning program. Please contact &nbsp;
       <a
        onClick={() => {
         window.open("mailto:LKM.ABCUniversity@accenture.com");
        }}
        href=""
       >
        LKM.ABCUniversity@accenture.com
       </a>
       &nbsp; for any queries regarding the program.
      </p>
     </div>
    )}
   </div>
  </>
 );
}

export default ToscaContent;
